class ProductsUpsell {

    constructor(element) {

        this.element = $(element);

        this.events();

    }

    events() {

        let self = this;

        $(document).on('click', '.product-upsell', function (e) {
            e.preventDefault();

            let variantId = $(this).data('variant-id');
            let amount = $(this).parent().parent().find('input[name="quantity"]').val();

            // if($(this).parent().parent().find('select option').length > 0) {
            //     variantId = $(this).parent().parent().find('select option:selected').val()
            // }

            self.add(variantId,amount);
        });

        $(document).on('change keyup', '.quantity-upsell', function (e) {

            let self = this;

            $.ajax({
                url: config.domain + '/frontend/functions/products_upsell_update.php',
                type: 'post',
                data: {
                    "id": $(self).data('variant-id'),
                    "quantity": $(self).val(),
                    "price": $(self).data('prices-graduated'),
                    "vatrate": $(self).data('vatrate'),
                },
                dataType: 'json',
                success: function (response) {
                    $(self).parent().parent().find('.card-price').html(getCurrency() + " " + formatPrice(response.price.primary));
                }
            });

        });
    }

    add(variantId,amount) {

        let self = this;

        $.ajax({
            url: config.domain + '/frontend/functions/products_upsell_add.php',
            type: 'post',
            data: {
                "id": variantId,
                "amount": amount
            },
            dataType: 'json',
            success: function (response) {

                let cartElem = $('.list-item[data-id="'+variantId+'"]');
                let upsellElem = $('.product-upsell[data-variant-id="'+variantId+'"]');

                if ( typeof updateTotals == 'function' ) { 
                    updateTotals(response);        
                } else {
                    if (response.count == 1) {
                        $('.cart-items-count').html(response.count + " " + $('.cart-items-count').data('single'));
                    } else {
                        $('.cart-items-count').html(response.count + " " + $('.cart-items-count').data('multiple'));
                    }
                }
                
                if ( typeof updatePromotionCode == 'function' ) { 
                    updatePromotionCode(response);
                }

                $('.cart-items-count').next().html((config.webshop.type == 'B2C'
                        ? getLocalePrice(response.totals.total.incl)
                        : getLocalePrice(response.totals.total.excl)));

                if(cartElem.length > 0) {      
                    let totalQuantity = parseInt(amount) + parseInt(cartElem.find('input[name="amount"]').val());
                    cartElem.find('input[name="amount"]').val(totalQuantity);
    
                    cartElem.find('.area-price').html((config.webshop.type == 'B2C'
                            ? getLocalePrice(response.item.price_incl_total)
                            : getLocalePrice(response.item.price_excl_total)))
                } else {
                    self.addToCart(response);
                }

                upsellElem.find('i').addClass('d-none');
                upsellElem.find('.toggle-btn-text').removeClass('d-none');
                setTimeout(function () {
                    upsellElem.find('i').removeClass('d-none');
                    upsellElem.find('.toggle-btn-text').addClass('d-none');
                },3000);

            }
        });
    }

    addToCart(data) {

        let variants = '';
        if(data.item.variants.length > 0) {
            variants = '<br>'+data.item.variants.join(" <br> ");
        }

        $('.shoppingcart-body').append(''+
                
            '<div class="list-item px-3 " data-id="'+data.item.id+'">'+
                '<div class="area area-image pl-0">'+
                    '<a href="'+config.domain+'/'+data.item.slug+'"> '+
                        '<div class="ratio ratio-4x3 ratio-cover"> '+
                            '<div class="inner "> '+
                                '<img src="'+data.item.image+'" class="rounded border"> '+
                            '</div> '+
                        '</div>'+
                    '</a>'+
                '</div>'+
                '<div class="area area-title table-title mb-1 md-lg-0">'+
                    '<a href="'+config.domain+'/'+data.item.slug+'" class="table-title">'+
                        ''+data.item.title+''+
                    '</a>'+
                '</div>'+
                '<div class="area area-text table-item">'+
                    $('.shoppingcart-body').data('translate-sku')+': '+data.item.sku+''+
                    ''+variants+''+
                '</div>'+
                '<div class="area area-quantity">'+
                    '<input type="number" class="form-control" value="'+data.item.quantity+'" min="1" max="250" name="amount">'+
                '</div>'+
                '<div class="area area-price table-item">'+
                    (config.webshop.type == 'B2C'
                        ? getLocalePrice(data.item.price_incl_total)
                        : getLocalePrice(data.item.price_excl_total))
                +'</div>'+
                '<div class="area area-delete">'+
                    '<a class="btn-remove-cart-item" href="'+config.url_shoppingcart+'/remove/'+data.item.id+'">'+
                        '<i class="fa fa-times"></i>'+
                    '</a>'+
                '</div>'+
            '</div>'+
        '');
    }

}
